export default "__VITE_PUBLIC_ASSET__b6e9ac0f__"